export default {
    menu: {
        notdone: 'Not done',
        profile: 'Profile',
        login: 'Login',
        logout: 'Log Out',
        relog: 'Relog',
        request: 'Requests',
        requestAdd: 'Send Request',
        requestMetroAdd: 'Send recruitment request',
        requestMetroApproval: 'Recruitment requests approval',
        requestMetro: 'Recruitment requests',
        approvalPerson: 'People approval',
        approvalProject: 'Vacancies approval',
        project: 'Project REC portfolio',
        approvalGroupTitle: 'Approval',
        projectGroupTitle: 'Project',
        requestGroupTitle: 'Request for a Vacancy',
        worksheet: 'Summary REC project: «%(project)s»',
        worksheetMass: 'Summary MAP project: «%(project)s»',
        main: 'Main',
        communicator: 'Communicator',
        calendar: 'Calendar',
        projectMass: 'Project MASS portfolio',

        education: 'Employee\'s My Office',
        actionVacancy: 'Application T&D',
        application: 'Applications',
        approvalApplication: 'Applications approval',
        events: 'Events',
        courses: 'Courses',
        scenario: 'Scenario: «%(scenario)s»',
        trainerEvents: 'Trainer events',
        trainerTimetable: 'Trainer timetable',
        personTimetable: 'Person timetable',
        remoteCourse: 'Remote course: «%(name)s»',
        remoteAssesment: 'Remote assessment: «%(name)s»',
        news: 'News',
        fileLibrary: 'Documents',

        metroRequest: 'Send request',
        metroRequestEdit: 'Edit request',
        metroRequestApproval: 'Request approval',
        metroRequests: 'Requests',
        metroRequestsApproval: 'Approval of applications',
    },
};
